import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { SelectOption } from "shared/types/Select"
import { WithClassName } from "shared/types/WithClassName"
import { Select } from "shared/ui/input/select/select/Select"

export interface ProductFilterProductGroupInputProps extends WithClassName {
  options: SelectOption<string>[] | undefined
  loading?: boolean
  disabled?: boolean
  elevated?: boolean
}

export const ProductFilterProductGroupInput = React.memo(
  ({
    options,
    loading,
    disabled,
    elevated,
    className
  }: ProductFilterProductGroupInputProps) => {
    const { t } = useTranslation()

    const renderValue = useCallback(
      () => <span className="select__placeholder">{t("General.Select")}</span>,
      [t]
    )

    return (
      <Select.Root
        name="productGroups"
        label={t("Product.Groups")}
        loading={loading}
        disabled={disabled}
        elevated={elevated}
        className={classNames("product-filter__product-groups", className)}
      >
        <Select.Label />
        <Select.Input options={options} isMulti renderValue={renderValue} />
      </Select.Root>
    )
  }
)

ProductFilterProductGroupInput.displayName = "ProductFilterProductGroupInput"
